import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ImageHomeHouse from "../../images/website/home-house.png";
import ImageHomeId from "../../images/website/home-id.png";
import ImageHomePersonal from "../../images/website/home-personal.png";
import ImageHomeV from "../../images/website/home-v.png";
import ImageHomeSimple from "../../images/website/home-simple.png";
import ImageLandlord1 from "../../images/website/landlord_1.png";
import ImageLandlord2 from "../../images/website/landlord_2.png";
import ImageTransparent from "../../images/website/transparent.png";
import ImageMoney1 from "../../images/website/money_1.png";
import ImageTenant1 from "../../images/website/tenant_1.png";
import ImageTenant2 from "../../images/website/tenant_2.png";
import ImageTenant3 from "../../images/website/tenant_3.png";
import ImageTenant4 from "../../images/website/tenant_4.png";
import ImageHero from "../../images/website/hero.png";
import LayoutWebsite from "../../components/LayoutWebsite";
import FooterWebsite from "../../components/FooterWebsite";
import { ApplicationPath } from "../../constants";
import "./styles.css";

function WebsiteHome() {
  const securities = [
    {
      imgSrc: ImageHomeHouse,
      text: "Digital listings are safe and easy - no one needs to come into your apartment",
    },
    {
      imgSrc: ImageHomeId,
      text: "None of your personal information is made public",
    },
    {
      imgSrc: ImageHomePersonal,
      text: "Most tenants interested in leasing your apartment will be through your friends!",
    },
    {
      imgSrc: ImageHomeV,
      text: "All payment transfers are made through Venmo Business - a safe method",
    },
  ];

  return (
    <LayoutWebsite>
      <div className="landing-page">
        <header className="hero">
          <Grid className="container" container>
            <Grid
              item
              md={6}
              sx={{
                display: {
                  xs: "none",
                  md: "block",
                },
              }}
            >
              <Box
                sx={{
                  marginBottom: {
                    md: "-45px",
                  },
                }}
              >
                <img src={ImageHero} style={{ width: "100%" }} />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: {
                  md: "flex",
                },
                flexDirection: {
                  md: "column",
                },
                justifyContent: {
                  md: "center",
                },
                paddingTop: {
                  xs: "2rem",
                  me: 0,
                },
                paddingBottom: {
                  xs: "4rem",
                  md: "0",
                },
              }}
            >
              <Typography variant="h3" component="h1">
                <strong>
                  It's time for landlords and tenants to work together
                </strong>
              </Typography>
              <Typography variant="body1" component="p">
                There's money to be made on move out day
              </Typography>
              <a href={ApplicationPath.Register}>SIGN UP</a>
            </Grid>
          </Grid>
        </header>
        <section className="landlord" id="landlord">
          <Grid container className="container" spacing={{ xs: 0, md: 4 }}>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: {
                  md: "flex",
                },
                flexDirection: {
                  md: "column",
                },
                justifyContent: {
                  md: "center",
                },
              }}
            >
              <Typography variant="h4" component="h2">
                <strong>Landlords can save $765</strong>
              </Typography>
              <Typography variant="body1" component="p">
                A single unit apartment vacancy cost landlords on average $1700.
                RentBeets renter referral program reduces days of empty
                apartments, increasing cashflow.
              </Typography>
              <Box
                sx={{
                  margin: "0 auto",
                  marginTop: "2rem",
                  display: {
                    xs: "none",
                    md: "block",
                  },
                }}
              >
                <img
                  src={ImageLandlord1}
                  style={{ maxWidth: "100px", width: "80%" }}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                paddingTop: {
                  xs: "2rem",
                  md: 0,
                },
                display: "flex",
                justifyContent: {
                  xs: "center",
                  md: "right",
                },
              }}
            >
              <img
                src={ImageLandlord2}
                style={{ maxWidth: "500px", width: "80%" }}
              />
            </Grid>
          </Grid>
        </section>
        <section className="tenant" id="tenant">
          <Grid container className="container">
            <Grid
              item
              md={3}
              sx={{
                display: {
                  xs: "none",
                  md: "block",
                },
              }}
            >
              <img src={ImageTenant1} className="image-tenant-1" />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: {
                  md: "flex",
                },
                flexDirection: {
                  md: "column",
                },
                justifyContent: {
                  md: "center",
                },
                textAlign: {
                  md: "center",
                },
                padding: {
                  xs: "6rem 0",
                  md: "0",
                },
                minHeight: {
                  xs: "none",
                  md: "600px",
                },
              }}
            >
              <Typography variant="h4" component="h2">
                <strong>Trusted and referred tenants</strong>
              </Typography>
              <Typography variant="body1" component="p">
                LANDLORDS, by allowing your tenant to digitally market their
                vacant apartment you ATTRACT trustworthy tenants, ENABLE
                transparent relationships, CREATE better living experiences.
              </Typography>
              <Box sx={{ textAlign: "center", paddingTop: "2rem" }}>
                <img className="image-tenant-4" src={ImageTenant4} />
              </Box>
            </Grid>
            <Grid
              item
              md={3}
              sx={{
                display: {
                  xs: "none",
                  md: "flex",
                },
                flexDirection: {
                  md: "column",
                },
                justifyContent: {
                  md: "center",
                },
              }}
            >
              <img className="image-tenant-2" src={ImageTenant2} />
              <img className="image-tenant-3" src={ImageTenant3} />
            </Grid>
          </Grid>
        </section>
        <section className="why" id="why">
          <Grid className="container">
            <Typography variant="h4" component="h2">
              <strong>Simple process</strong>
            </Typography>
            <Grid container spacing={{ xs: 2, md: 8 }}>
              <Grid item xs={12} md={6} style={{ display: "flex" }}>
                <div>
                  <div className="number">1</div>
                </div>
                <div>
                  <Typography variant="h6" component="h3">
                    <strong>Coordinate with tenants</strong>
                  </Typography>
                  <Typography variant="body1" component="p">
                    Landlord, create a new lease and invite departing tenants to
                    sign up on RentBeets.
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} md={6} style={{ display: "flex" }}>
                <div>
                  <div className="number">2</div>
                </div>
                <div>
                  <Typography variant="h6" component="h3">
                    <strong>Tenants take action</strong>
                  </Typography>
                  <Typography variant="body1" component="p">
                    Departing tenants submit photos and reviews and receive
                    a URL that can be shared by text, email or social media.
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} md={6} style={{ display: "flex" }}>
                <div>
                  <div className="number">3</div>
                </div>
                <div>
                  <Typography variant="h6" component="h3">
                    <strong>New tenant is found</strong>
                  </Typography>
                  <Typography variant="body1" component="p">
                    Referred tenants are prescreened giving confidence to
                    landlords before a lease is signed.
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} md={6} style={{ display: "flex" }}>
                <div>
                  <div className="number">4</div>
                </div>
                <div>
                  <Typography variant="h6" component="h3">
                    <strong>Happy ending (Reward):</strong>
                  </Typography>
                  <Typography variant="body1" component="p">
                    When referred tenant signs lease, departing tenant gets
                    PAID!!!!
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </section>
        <div className="small_devider" />
        <section className="transparent">
          <Grid container className="container" spacing={{ xs: 0, md: 6 }}>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: {
                  md: "flex",
                },
                justifyContent: {
                  md: "left",
                },
              }}
            >
              <img
                src={ImageTransparent}
                style={{ maxWidth: "540px", width: "80%" }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                paddingTop: {
                  xs: "2rem",
                  md: 0,
                },
                display: {
                  md: "flex",
                },
                flexDirection: {
                  md: "column",
                },
                justifyContent: {
                  md: "center",
                },
              }}
            >
              <Typography variant="h4" component="h2">
                <strong>Transparent and secure</strong>
              </Typography>
              <ul>
                <li>
                  <Typography variant="body1" component="p">
                    Prospective tenants are fully vetted using &nbsp;
                    <a href="www.mysmartmove.com" target="_blank">
                      www.mysmartmove.com
                    </a>
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" component="p">
                    no downloading software, no monthly subscriptions
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" component="p">
                    Encourages honest reviews from departing tenants
                  </Typography>
                </li>
              </ul>
            </Grid>
          </Grid>
        </section>
        <section className="money">
          <Grid container className="container" spacing={{ xs: 0, md: 4 }}>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: {
                  md: "flex",
                },
                flexDirection: {
                  md: "column",
                },
                justifyContent: {
                  md: "center",
                },
              }}
            >
              <Typography variant="h4" component="h2">
                <strong>Departing Tenants</strong>
              </Typography>
              <Typography variant="body1" component="p">
                Make money when you move out by referring your apartment to
                friends. You deserve to get rewarded for being a responsible,
                respectful tenant and now you can with RentBeets.
              </Typography>
              <Typography
                variant="h4"
                component="h2"
                sx={{ marginTop: "2rem" }}
              >
                <strong>Prospective Tenants</strong>
              </Typography>
              <Typography variant="body1" component="p">
                Stop risking bad living experiences. RentBeets platform allows
                the departing tenant to provide details of the apartment you are
                interested in. Request your landlord participates in RentBeets
                so you can make money by sending them our website!
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                justifyContent: {
                  xs: "center",
                  md: "right",
                },
              }}
            >
              <img
                src={ImageMoney1}
                style={{ maxWidth: "500px", width: "80%" }}
              />
            </Grid>
          </Grid>
        </section>
        <section className="simple">
          <Grid container className="container">
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                textAlign: "center",
              }}
            >
              <img src={ImageHomeSimple} style={{ width: "80%" }} />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: {
                  md: "flex",
                },
                justifyContent: {
                  md: "center",
                },
                flexDirection: {
                  md: "column",
                },
              }}
            >
              <Typography variant="h4" component="h2">
                <strong>Simple and easy!</strong>
              </Typography>
              <ul>
                <li>
                  <Typography variant="body1" component="p">
                    Upload photos of your apartment
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" component="p">
                    Add comments about your living experience
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" component="p">
                    Share your listing referral ID link with your social
                    networks
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1" component="p">
                    You get paid a referral reward! Receive compensation from
                    your Landlord based on date apartment is leased
                  </Typography>
                </li>
              </ul>
            </Grid>
          </Grid>
        </section>
        <div className="small_devider_with_image" />
        <section className="security">
          <div className="container">
            <Typography
              variant="h4"
              component="h2"
              sx={{
                textAlign: {
                  md: "center",
                },
                marginBottom: "2rem",
              }}
            >
              <strong>We take your security very seriously</strong>
            </Typography>

            <Grid container spacing={{ xs: 2, md: 4 }}>
              {securities.map((security, index) => (
                <Grid item xs={12} md={3} key={index}>
                  <Box
                    className="card"
                    sx={{
                      height: {
                        xs: "auto",
                        md: "100%",
                      },
                      padding: {
                        xs: "2rem",
                        md: "2rem 2rem 0 2rem",
                      },
                    }}
                  >
                    <img src={security.imgSrc} />
                    {security.text}
                  </Box>
                </Grid>
              ))}
            </Grid>
          </div>
        </section>
        <FooterWebsite />
      </div>
    </LayoutWebsite>
  );
}

export default WebsiteHome;
